import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import AdminDashItems from "../../../../data/AdminDashItems.json"
import SettingDashItems from "../../../../data/SettingDashItems.json"
import { useAdmin } from '../../../../context/Admins/AdminContext';

export default function AdminDashboardList() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const [selectedDashItem, setSelectedDashItem] = useState("");
    const [selectedSettingItem, setSelectedSettingItem] = useState("");
    const [settingOpen, setSettingOpen] = useState(false);
    const { profile } = useAdmin();

    // Set selectedDashItem based on the current location
    useEffect(() => {
        const pathname = location.pathname;
        setSelectedDashItem(pathname);
        setSelectedSettingItem(pathname);

        // Match both "/setting/..." and "/admin/setting/..."
        const isSettingPath = /^\/(admin\/)?setting(\/.+)?$/.test(pathname);
        setSettingOpen(isSettingPath);
    }, [location]);

    const showList = "d-none";

    // /setting/books
    return (
        <>
            {
                AdminDashItems
                    .filter(item => item.id !== 4)
                    .map((item, index) => (
                        <li
                            key={index}
                            className={`admin list-group-item list-group-item-action ps-2 ${selectedDashItem === `/admin${item.link}` ? 'active' : ''} `} aria-current={selectedDashItem === `/admin${item.link}` && "true"}>
                            <Link to={`/admin${item.link}`} className={`d-block text-decoration-none ${selectedDashItem === `/admin${item.link}` ? 'c-darkBeige' : 'text-white'} ${item.id === 3 & profile?.data?.role !== item.adminRole && showList}`} >
                                {i18n.language === "ar" ? item.itemNameAr : item.itemNameEn}
                            </Link>
                        </li>

                    ))
            }
            {
                AdminDashItems
                    .filter(item => item.id === 4)
                    .map((item, index) => (
                        <li
                            key={index}
                            className={`admin list-group-item list-group-item-action ps-2 ${settingOpen ? 'active' : ''}`} aria-current={settingOpen && "true"}>
                            <Link to={`/admin${item.link}/books`} className={`d-block text-decoration-none ${settingOpen ? 'c-darkBeige' : 'text-white'}`} >
                                {i18n.language === "ar" ? item.itemNameAr : item.itemNameEn}
                            </Link>
                        </li>

                    ))
            }
            {settingOpen &&
                <ul className="list-group">
                    {SettingDashItems.map((item, index) => (
                        <li key={index} className={`admin list-group-item list-group-item-action ps-2 ${selectedSettingItem === item.link ? 'active' : ''}`} aria-current={selectedSettingItem === `/admin${item.link}` && "true"}>
                            <Link to={`/admin${item.link}`} className={`ps-3 d-block text-decoration-none  ${selectedSettingItem === `/admin${item.link}` ? 'c-darkBeige-10' : 'text-light'}`}>
                                {i18n.language === "ar" ? item.itemNameAr : item.itemNameEn}
                            </Link>
                        </li>
                    ))}
                </ul>
            }
        </>

    )
}
